{
  "COMMON": {
    "SAVE": "Save",
    "SAVE_AND_CONTINUE": "Save and continue",
    "NEXT": "Next",
    "BACK": "Back",
    "EDIT": "Edit",
    "CANCEL": "Cancel",
    "CLOSE": "Close",
    "DELETE": "Delete",
    "INVALID_FORM": "Form is invalid",
    "ERROR_OCCURRED": "An error occurred",
    "YES": "Yes",
    "NO": "No"
  },
  "AI_KNOWLEDGE_BASE": "AI knowledge base",
  "MANAGE_KNOWLEDGE": "Manage knowledge",
  "MANAGE_KNOWLEDGE_DESCRIPTION": "Provide information AI can use when creating content or answering inqueries",
  "REFRESH_OPTIONS": "Refresh options",
  "CHOOSE_KNOWLEDGE_SOURCES": "Choose the knowledge sources that the AI assistant will reference when responding to inquiries",
  "KNOWLEDGE_SOURCES": "Knowledge sources",
  "ADD_KNOWLEDGE": "Add knowledge",
  "ADD_NEW_KNOWLEDGE": "+ Add new knowledge",
  "SELECT_KNOWLEDGE": "Select knowledge",
  "APPLICATION_SETTINGS": "Settings",
  "APPS_WARNING": "This knowledge is currently being used by the following:",
  "NO_APPS": "This knowledge is not currently being used.",
  "NO_MATCHING_KNOWLEDGE_SOURCES": "No knowledge available",
  "WEBSITE_SCRAPE": {
    "LAST_SCRAPED": "Last scraped {{lastScraped}}"
  },
  "EDIT_KNOWLEDGE": {
    "TITLE": "Edit knowledge",
    "NAME": "Name",
    "CUSTOM_DATA_CONFIG": {
      "TITLE": "Custom data",
      "DESCRIPTION": "Text content related to your business such as FAQs or information snippets",
      "CONTENT": "Content",
      "CONTENT_HINT": "Enter any text content related to your business such as FAQs, so AI can accurately answer questions and create content about your business."
    },
    "WEBSITE_SCRAPE_CONFIG": {
      "TITLE": "Website scrape",
      "DESCRIPTION": "Scrape content from a website",
      "URL": "URL",
      "INVALID_URL": "Please enter a valid URL",
      "CRAWL_MODE": "Mode",
      "SINGLE_PAGE": "Single page",
      "FOLLOW_LINKS": "Follow links",
      "FOLLOW_LINKS_HINT": "Will find up to {{pageLimit}} pages by following links from this domain starting on the provided URL",
      "PAGES": "Pages",
      "NUMBER_OF_PAGES_TRAINED": "Trained on {{trainedPagesCount}} of {{scrapedPagesCount}} scraped pages",
      "SELECT_PAGES_TO_TRAIN": "Choose which pages to train on",
      "SELECT_ALL": "Select all ({{scrapedPagesCount}} pages)",
      "SCRAPE_QUEUED": "Scrape is queued",
      "SCRAPE_IN_PROGRESS": "Scrape in progress",
      "SCRAPE_IN_PROGRESS_CLARIFICATION_DEFAULT": "Training will begin by default on the URL entered, this may take a few minutes. Closing this panel will not interrupt this process.",
      "SCRAPE_IN_PROGRESS_CLARIFICATION": "Additional pages to train on will appear here once scraping has completed",
      "PAGE_TITLE": "Page title"
    },
    "REQUIRED_FIELD": "Required"
  },
  "DELETE_KNOWLEDGE": {
    "TITLE": "Delete custom knowledge?"
  },
  "BUSINESS_PROFILE": {
    "BUSINESS_PROFILE": "Business Profile",
    "ALLOW_ACCESS": "Allow access to your business profile",
    "DESCRIPTION": "Answer questions about your business contact information, hours, products and services you offer.",
    "MANAGE_BUSINESS_PROFILE": "Manage business profile",
    "LEARN_MORE": {
      "TITLE": "Learn more",
      "WHAT_INFORMATION_QUESTION": "What information is made available to your AI assistant?",
      "WHAT_INFORMATION": "These fields are shared from your business profile:",
      "BUSINESS_NAME": "Business name",
      "ADDRESS_SERVICE_AREAS": "Address and/or service areas",
      "WEBSITE": "Website",
      "PHONE_NUMBER": "Phone number",
      "CATEGORIES": "Categories",
      "HOURS": "Hours",
      "SERVICES_OFFERED": "Services offered",
      "SHORT_DESCRIPTION": "Short description",
      "LONG_DESCRIPTION": "Long description",
      "SOCIAL_MEDIA_URLS": "Social media URLs",
      "BOOKING_URL": "Booking URL"
    }
  },
  "INBOX_SETTINGS": {
    "PROMPT": "Add knowledge to your Web Chat widget",
    "DESCRIPTION": "This knowledge and others can be added to your Web Chat widget via the Inbox settings page",
    "GO_TO": "Go to Inbox settings"
  },
  "UNSAVED_CHANGES": {
    "TITLE": "Any unsaved changes will be lost",
    "MESSAGE": "Do you wish to proceed?"
  }
}
